import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApproveManPowerWithTokenDto} from 'src/app/models/ApproveManPowerWithTokenDto';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { ContractApprovalService } from 'src/app/services/contract-approval.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { SharedService } from 'src/app/services/shared.service';
import { TokenService } from 'src/app/services/token.service';
import { ManpowerComponent } from '../manpower/manpower.component';

@Component({
  selector: 'app-approvemnp',
  templateUrl: './approvemnp.component.html',
  styleUrls: ['./approvemnp.component.css']
})
export class ApprovemnpComponent implements OnInit {

 
  token: string="";
  hasUserApprovedContract:boolean=false;
  contract:any;
  ViewlevelOfCompliance = false;
  UpdateRequest:any;
  currentUser: any;
  RequestApprovals: RequestApprovalDto[] | undefined;


  constructor(private location:Location ,  private route: ActivatedRoute,  private tokenService: TokenService, private router: Router,
    private notification: NotificationService, private sharedService: SharedService,    private contractApprovalService :ContractApprovalService,
    private requestApprovalService: RequestApprovalsService,  private ManpowerService: ManpowerComponent,  private _ActivatedRoute: ActivatedRoute  ) 
    { 
     
  }
  ngOnInit(): void {
    this.route.queryParams
    .subscribe(params => {
      console.log(params);  
      this.token = params.to;
      console.log(this.token);  
    }
  );

  if(this.token.length==0)
  {
    this.router.navigate(['/approverequests']);
  }

  // this.LoadData();
  //  this.location.replaceState(this.location.path().split('?')[0], '');
  ;


  var snapshot = this._ActivatedRoute.snapshot;
  const params = { ...snapshot.queryParams };
  delete params.pos
  this.router.navigate([], { queryParams: params });
}

async LoadData()
{
  
  let resLo = await this.contractApprovalService.BeginManpowerApproval(this.token).toPromise();
  var payload  = <ApproveManPowerWithTokenDto>resLo.responseData;
  
if(payload.hasUserApprovedContract)
{
this.hasUserApprovedContract = true;
}
this.UpdateRequest = payload.manpowerRequest;
window.localStorage.clear();
// store token
this.contract=payload.manpowerRequest;
this.sharedService.loginResponseData = payload.login;
this.tokenService.saveSession(payload.login);
this.tokenService.setInfo(payload.login);

//this.description = payload.contract.description;
//this.justification= payload.contract.justification;
//this.qualification = payload.contract.qualification;
let resApprovals = await this.requestApprovalService.getRequestApprovals(this.UpdateRequest.id).toPromise();
  this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;

  this.currentUser = this.tokenService.getInfo(); 

  if ((this.currentUser.profile.email == 'gbemiga.owolabi@ng.huaxin.com' || this.currentUser.profile.email == 'lolu.akinyemi@ng.huaxin.com')) { this.ViewlevelOfCompliance = true; }
   
    
}
cancel()
{
 this.router.navigateByUrl('/dashboard');
// this.router.navigate(['/dashboard']);
}

// onFileChange(event : any) {
//   ;
//   this.files = event.target.files;
//   this.file = this.files[0];
//   const reader = new FileReader();
//   reader.readAsDataURL(this.file);
//   reader.onload = () => {
//       this.DocumentContent = reader.result as string
//   };
// }


}
